import React from "react";
import "./produk.scss";
import data from "../../../src/Component/Card/data.json";
import Card from "../../../src/Component/Card/card";
import Ardeaimages from "../../media/Residentials/Ardea/Ardea";
import Heronimages from "../../media/Residentials/Heron/Heron";
import Strozziimages from "../../media/Residentials/Strozzi/Strozzi";
import Leonoraimages from "../../media/Residentials/Leonora/Leonora";
import Flamingoimages from "../../media/Residentials/Flamingo/Flamingo";
import Emeraldimages from "../../media/Residentials/Emerald Cove/Emerald";
import Carsonimages from "../../media/Residentials/Carson/Carson";
import Agnesiimages from "../../media/Residentials/Agnesi/Agenesi";
import Teslaimages from "../../media/Residentials/Tesla/Tesla";
import Mozartimages from "../../media/Residentials/Mozart/Mozart";
import Allogioimages from "../../media/Residentials/Allogio/Allogio";
import Baroniimages from "../../media/Residentials/Baroni/Baroni";
import Vivaldiimages from "../../media/Residentials/Vivaldi/Vivaldi";
import Louiseimages from "../../media/Residentials/Louise/Louise";

const imageMap = {
  Ardeaimages,
  Heronimages,
  Strozziimages,
  Leonoraimages,
  Flamingoimages,
  Emeraldimages,
  Carsonimages,
  Agnesiimages,
  Teslaimages,
  Mozartimages,
  Allogioimages,
  Baroniimages,
  Vivaldiimages,
  Louiseimages,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="rumah" className="produk">
      <h1>Our Residentials</h1>

      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
